import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import { EVENT_NAME, EVENT_NAME_LOGOUT } from './constants';
import { Tracker } from '../Tracker';

var EVENT_LABEL_NAMES = {
  feedback: 'Feedback',
  help: 'Help'
};

export var FooterTracker = function (_Tracker) {
  _inherits(FooterTracker, _Tracker);

  function FooterTracker() {
    _classCallCheck(this, FooterTracker);

    return _possibleConstructorReturn(this, (FooterTracker.__proto__ || _Object$getPrototypeOf(FooterTracker)).apply(this, arguments));
  }

  _createClass(FooterTracker, [{
    key: 'footerItemClicked',
    value: function footerItemClicked(id) {
      this.publishPartialEvent(EVENT_NAME, {
        ElementType: 'Spitfire',
        EventLabel: EVENT_LABEL_NAMES[id] || id
      });
    }
  }, {
    key: 'logoutItemClicked',
    value: function logoutItemClicked() {
      this.publishPartialEvent(EVENT_NAME_LOGOUT, {
        ElementType: 'Spitfire',
        LogoutOption: 'Manual Logout'
      });
    }
  }]);

  return FooterTracker;
}(Tracker);